export default "__VITE_ASSET__fc94c2c6__"